import { useEffect, useState } from "react";

import styles from "./style.module.scss";
import { SuscriptionDataType } from "@/api/SuscriptionsApi";
import { stripHtmlTags } from "@utils/Utils";
import { generateS3AssetUrl } from "@utils/FormFileServer";
import { useExportReadiness } from "@utils/exportReadiness";

type PrintPageHeaderProps = {
  suscription?: SuscriptionDataType
}

const PrintPageHeader = (props: PrintPageHeaderProps) => {
  const { suscription } = props
  const readiness = useExportReadiness();
  const [mainLogo, setMainLogo] = useState<URL>()
  const [alternateLogo, setAlternateLogo] = useState<URL>()

  useEffect(() => {
    loadLogos()
  }, [suscription]);

  /**
   * Resolver la URL firmada de los logos es el ultimo trabajo asincrono entre el
   * montaje de la vista de impresion y el DOM definitivo: alimenta el `<img src>`
   * que wkhtmltopdf va a buscar despues. Se registra en el `ExportReadiness` para
   * que el PDF no se serialice antes de que el logo este en el DOM.
   *
   * Fuera de un portal de exportacion el registro es inerte (ver `exportReadiness`),
   * asi que la ruta de impresion normal no cambia.
   */
  const loadLogos = async () => {
    const release = readiness.begin();
    try {
      if (suscription?.logo) {
        const logo = await generateS3AssetUrl(suscription?.logo);
        setMainLogo(logo.url)
      }
      if (suscription?.logo2) {
        const logo2 = await generateS3AssetUrl(suscription?.logo2);
        setAlternateLogo(logo2.url)
      }
    } catch (err) {
      // Un logo que no resuelve degrada a "documento sin logo", no debe tumbar la
      // impresion ni la generacion del PDF.
      console.error("No fue posible resolver el logo de la suscripcion", err);
    } finally {
      release();
    }
  }

  return suscription && (
    <header>
      <div id="suscription-info">
        <h1>{suscription.nombre}</h1>
        <h2><b>Identificación:</b> {suscription.identificacion}</h2>
        <h2><b>Tel:</b> {`${suscription.telefono1 || ""} / ${suscription.telefono2 || ""}`}</h2>
        <h2><b>Direccion:</b> {stripHtmlTags(`${suscription.direccion}`)} </h2>
      </div>
      <div className="page-logo-wrapper">
        <div className="page-logo">
          {mainLogo && (<img src={`${mainLogo}`} />)}
        </div>
        <div className="page-logo-alt">
          {alternateLogo && (<img src={`${alternateLogo}`} />)}
        </div>
      </div>
    </header>
  );
}

export default PrintPageHeader
  ;
